export type TrackingConsent = {
    analytics : boolean;
    advertisement : boolean;
};

export type TrackingDestinations = {
    dataLayer : boolean;
    posthog : boolean;
};

export const resolveTrackingDestinations = (consent : TrackingConsent) : TrackingDestinations => ({
    dataLayer: consent.analytics || consent.advertisement,
    posthog: consent.analytics,
});
